import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import gpickr from '@/components/mapv2/gpickr';
import fontStyle from '@/components/mapv2/fontstyle';
import { mapMutations } from 'vuex';
export default {
  props: {
    globalvalue: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: {}
    }
  },
  components: {
    fontStyle,
    gpickr
  },
  data() {
    return {
      fontname: 'pointtext',
      limit: {
        flag: false,
        rows: 1,
        len: 10
      },
      fill: 'rgba(51,51,51,1)',
      stroke: '',
      style: {},
      defaultfont: {},
      textalignOptions: [{
        label: '左对齐',
        value: 'left'
      }, {
        label: '右对齐',
        value: 'left'
      }, {
        label: '居中对齐',
        value: 'left'
      }]
    };
  },
  watch: {
    value: {
      handler(val) {
        // console.log(`watch-value`, val)
        if (val) {
          this.commonHandle(val);
        }
      },
      deep: true
    },
    globalvalue: {
      handler(val) {
        // console.log(`globalvalue`, val)
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      // console.log(`this.value`, this.value)
      if (Object.keys(this.value).length > 0) {
        this.commonHandle(this.value);
      } else {
        this.limitChange();
      }
    });
  },
  methods: {
    ...mapMutations(['SET_MAPSTYLEITEM']),
    fontChange(val) {
      Object.keys(val[this.fontname]).forEach(key => {
        this.style[key] = val[this.fontname][key];
      });
      this.updateChange();
    },
    colorHandle(val, type) {
      this.style[type] = val;
      this.updateChange();
    },
    limitChange(val) {
      this.style.limit = this.limit;
      this.updateChange();
    },
    updateChange() {
      // console.log(`this.globalvalue-updateChange`, this.globalvalue)
      if (!this.globalvalue) {
        this.$emit('data', this.style);
      } else {
        this.SET_MAPSTYLEITEM({
          pointtext: this.style
        });
      }
    },
    commonHandle(val) {
      // console.log(`this.globalvalue-commonHandle`, this.globalvalue)
      this.style = {};
      this.style = {
        ...val
      };
      this.defaultfont = Object.assign({}, this.style);
      this.limit = this.style.limit;
      this.fill = this.style.fill;
      this.stroke = this.style.stroke;
      if (!this.globalvalue) {
        this.$emit('data', this.style);
      } else {
        this.SET_MAPSTYLEITEM({
          pointtext: this.style
        });
      }
    }
  }
};